<template>
  <v-container fluid>
    <vue-headful title="SMS" description="Online-Service Administration"/>
    <v-row>
      <v-col>
        <div class="pb-3">
          <h1 class="display-1" style="color:#d30228;">SMS</h1>
        </div>
      </v-col>
    </v-row>
    <v-row class="pl-3">
      <p>Current Balance on <a href="https://app.sms77.io/login" target="_blank">sms77.io</a>: € <span class="blue--text">{{formatBetrag(stats.balance)}}</span></p>
    </v-row>
    <v-divider class="my-5"></v-divider>

    <v-row class="ml-0 mt-3" style="min-height: 40px;">
      <v-btn v-if="changed" dark @click="save">Speichern</v-btn>
      <v-btn v-if="changed" class="ml-3" @click="load">Abbrechen</v-btn>
    </v-row>

    <div class="pl-3 mt-3" style="min-height: 40px;">

    <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>

    <v-simple-table class="ml-n3">
      <tr>
        <td style="width:640px">
          <span class="headline mt-n5">SMS-Reminder:</span>
          <div>
            <v-textarea class="mt-2" v-model="settings_edited.erinnerungstext" label="SMS-Reminder" counter/>
          </div>
        </td>
        <td class="pa-4 pt-0" style="vertical-align: top;">
          Variablen:<br/><br/>
          <!--          vars-->
          <div v-for="(v,i) in vars" :key="i">
            <b>{{ v['var'] }}</b><br/>
            {{ v.description }}
          </div>
        </td>
      </tr>
    </v-simple-table>
    </div>

    <v-divider class="my-5"></v-divider>
    <div style="width: 600px;">
      <h1 class="headline" style="color:#d30228;">Test-SMS</h1>
      <p class="body-2 mt-2">Achtung: ohne Ländervorwahl (z.B +43 für Österreich) geht die SMS nach Deutschland.</p>
      <v-row>
        <v-text-field class="mx-3 my-3" v-model="phone" label="Mobilnummer" placeholder="+43 680 12345678" ></v-text-field>
<!--        <v-text-field class="mx-3 my-3" v-model="text" label="Text" placeholder="SMS Text"></v-text-field>-->
        <v-btn class="ml-3 mt-5" @click="onSendTestSms" color="primary" :disabled="!phone">Test-SMS versenden</v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>

  import {formatBetrag} from "@/pepper";

  const SETTINGS_CONTEXT = "sms";
  export default {
    name: 'Service_Sms',
    components: {},
    data() {
      return {
        stats: {},
        settings: {},
        settings_edited: {},
        vars: [
            {var:"{datumMitWochentag}", description:"Erinnerungsdatum (20 Zeichen)" },
            {var:"{url}", description:"Eingabelink (50 Zeichen)" },
        ],
        changed: false,
        loading: false,
        reason: '',
        error: false,
        phone: '',
        text: 'Schöne Grüße von AIMZ',
      }
    },
    mounted() {
      this.load();
    },
    methods: {
      async load() {
        this.loading = true;
        var data=await this.$backend.get_sms_stats();
        this.loading = true;
        this.settings=await this.$backend.get_settings("sms", );
        this.settings_edited= JSON.parse(JSON.stringify(this.settings));
        this.changed=false;
        this.loading = false;
        this.stats = data;
      },
      save() {
        this.loading = true;
        this.$backend.set_settings(SETTINGS_CONTEXT, this.settings_edited, {
          onSuccess: this.onSaveSuccess,
          onError: this.onSaveError
        });
        this.load();
      },
      onSaveSuccess(data) {
        this.loading = false;
        this.settings = data;
        this.settings_edited = JSON.parse(JSON.stringify(data));
      },
      onSaveError(reason) {
        this.loading = false;
        this.error = true;
        this.reason = reason;
        this.load();
      },
      async onSendTestSms() {
        var success=await this.$backend.send_sms(this.phone, "erinnerungstext");
        this.$events.$emit(success ? "notify" : "error", success ? "SMS erfolgreich gesendet" : "Fehler!");
        this.load();
      },
      formatBetrag(x) {
        return formatBetrag(x, 3);
      }
    },
    computed: {
    },
    watch: {
      settings_edited: {
        deep: true,
        handler(o, n) {
          this.changed = JSON.stringify(this.settings) !== JSON.stringify(this.settings_edited);
        }
      }
    }
  }
</script>

<style scoped>
</style>
